export default function formHelperText({ variables }) {
    return {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: variables.text_medium,
                    marginTop: variables.spacing_01,
                },
            },
        },
    };
}
//# sourceMappingURL=formHelperText.js.map